import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
  Collapse,
  IconButton,
  Button,
  Stack,
  Tabs,
  Tab,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonIcon from "@mui/icons-material/Person";
import { useDispatch, useSelector } from "react-redux";
import {
  editOrder,
  getFamilyOrders,
  getOrdersCounter,
} from "../redux/slices/order/thunk";
import LoadingComponent from "../components/LoadingComponent";
import { Navigate } from "react-router-dom";
import { Cancel, Home, LocationOn, Phone } from "@mui/icons-material";

const FamilyOrders = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isSmallMobile = useMediaQuery("(max-width:400px)");
  const isRtl = i18n.dir() === "rtl";
  const [expandedOrders, setExpandedOrders] = React.useState({});
  const [tabValue, setTabValue] = React.useState(0);
  const user = JSON.parse(localStorage.getItem("user"));
  const { familyOrders } = useSelector((state) => state.orderSlice);

  // State to track which orders are being updated
  const [updatingOrders, setUpdatingOrders] = React.useState({});
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(null); // 'cancelled' | 'delivered' | null
  const [modalOrder, setModalOrder] = useState(null); // 'cancelled' | 'delivered' | null

  console.log("modalOrder",modalOrder);
  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      try {
        await dispatch(getFamilyOrders({ id: user?._id }));
        await dispatch(
          getOrdersCounter({
            id: user?._id,
            type: user?.type,
            status: "pending",
          })
        );
      } catch (error) {
        console.log("error", error);
      } finally {
        setLoading(false);
      }

    };

    fetchOrders();
     return () => {
      dispatch(
        getOrdersCounter({ id: user?._id, type: user?.type, status: "pending" })
      );
    };
  }, [dispatch, user?._id]);

  const handleConfirm = () => {
    handleUpdateStatus(modalOrder._id, openDialog);
    setOpenDialog(null);
  };
  // useEffect(() => {
  //   dispatch(getFamilyOrders({ id: user?._id }));
  //   dispatch(
  //     getOrdersCounter({ id: user?._id, type: user?.type, status: "pending" })
  //   );
  //   return () => {
  //     dispatch(
  //       getOrdersCounter({ id: user?._id, type: user?.type, status: "pending" })
  //     );
  //   };
  // }, [dispatch, user?._id]);

  // Transform orders to match frontend structure
  
  
  const transformOrders = (orders) => {
    return orders?.map((order) => ({
      _id: order._id,
      orderId: order?.orderNumber?.toUpperCase(), // Short ID for display
      orderDate: order?.createdAt,
      orderStatus: order?.orderStatus,
      buyer: {
        name: order?.userId?.userName || t("familyOrders.unknownBuyer"),
        avatar: order?.userId?.image || "",
        phone: order?.phone || order?.userId?.phoneNumber,
        address: order?.address || order?.userId?.address,
        location: order?.location || order?.userId?.location,
      },
      products: order?.products?.map((product) => ({
        id: product?.productId?._id || "",
        name: product?.productId?.name || t("familyOrders.unknownProduct"),
        image: product?.productId?.image || "",
        description: product?.productId?.description || "",
        price: product?.priceAfterDiscount,
        quantity: product?.quantity,
      })),
      totalPrice: order?.products?.reduce(
        (total, product) => total + product?.itemTotal,
        0
      ),
      notes: order?.familyNotes || "",
    }));
  };

  const transformedOrders = familyOrders ? transformOrders(familyOrders) : [];

  // Filter orders based on status
  const pendingOrders = transformedOrders.filter(
    (order) => order.orderStatus === "pending"
  );

  const deliveredOrders = transformedOrders.filter(
    (order) =>
      order.orderStatus == "delivered" || order.orderStatus == "cancelled"
  );

  const formatDate = (date) => {
    const d = new Date(date);
    return d.toLocaleDateString(i18n.language, {
      year: "numeric",
      month: "short",
      day: "numeric",
      // hour: "2-digit",
      // minute: "2-digit",
    });
  };

  const toggleOrder = (orderId) => {
    setExpandedOrders((prev) => ({
      ...prev,
      [orderId]: !prev[orderId],
    }));
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "delivered":
        return <CheckCircleIcon color="success" sx={{ ml: 1 }} />;
      case "in-transit":
        return <LocalShippingIcon color="primary" sx={{ ml: 1 }} />;
      case "cancelled":
        return <Cancel color="error" sx={{ ml: 1 }} />;
      case "pending":
        return <AccessTimeIcon color="warning" sx={{ ml: 1 }} />;
      default:
        return <AccessTimeIcon />;
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case "delivered":
        return t("orders.statusDelivered");
      case "in-transit":
        return t("orders.statusInTransit");
      case "cancelled":
        return t("orders.statusCancelled");
      case "pending":
        return t("orders.statusPending");
      default:
        return t("orders.statusUnknown");
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "delivered":
        return "success.main";
      case "in-transit":
        return "primary.main";
      case "cancelled":
        return "error.main";
      case "pending":
        return "warning.main";
      default:
        return "text.secondary";
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleUpdateStatus = async (orderId, status) => {
    setUpdatingOrders((prev) => ({ ...prev, [orderId]: true }));
    const data = {
      orderId,
      status,
    };
    try {
      await dispatch(
        editOrder({
          id: orderId,
          data,
        })
      );
      // Refresh orders after status update
      await dispatch(getFamilyOrders({ id: user?._id }));
      await dispatch(
        getOrdersCounter({ id: user?._id, type: user?.type, status: "pending" })
      );
    } catch (error) {
      console.error("Failed to update order status:", error);
    } finally {
      setUpdatingOrders((prev) => ({ ...prev, [orderId]: false }));
    }
  };

  if (user?.type !== "family") {
    return <Navigate to="/" replace />;
  }

  if (loading) {
    return <LoadingComponent />;
  }

  return (
    <Box
      sx={{
        px: isMobile ? 1 : 4,
        py: 2,
        direction: isRtl ? "rtl" : "ltr",
        backgroundColor:
          theme.palette.mode === "dark"
            ? theme.palette.grey[900]
            : theme.palette.grey[50],
        minHeight: "100vh",
      }}
    >
      <Typography
        variant={isMobile ? "h5" : "h4"}
        component="h1"
        gutterBottom
        sx={{
          fontWeight: 700,
          mb: 3,
          color: theme.palette.primary.main,
          textAlign: "center",
        }}
      >
        {t("familyOrders.title")}
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="fullWidth"
          textColor="primary"
          indicatorColor="primary"
        >
          <Tab
            label={
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="body1">
                  {t("familyOrders.newOrders")}
                </Typography>
              </Stack>
            }
          />
          <Tab
            label={
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="body1">
                  {t("familyOrders.deliveredOrders")}
                </Typography>
              </Stack>
            }
          />
        </Tabs>
      </Box>

      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
          <CircularProgress />
        </Box>
      )}

      {!loading && tabValue === 0 && pendingOrders.length === 0 && (
        <Box
          sx={{
            textAlign: "center",
            py: isMobile ? 5 : 10,
            backgroundColor: theme.palette.background.paper,
            borderRadius: 2,
            boxShadow: theme.shadows[1],
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            {t("familyOrders.noNewOrders")}
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
            {t("familyOrders.noNewOrdersDesc")}
          </Typography>
        </Box>
      )}

      {!loading && tabValue === 1 && deliveredOrders.length === 0 && (
        <Box
          sx={{
            textAlign: "center",
            py: isMobile ? 5 : 10,
            backgroundColor: theme.palette.background.paper,
            borderRadius: 2,
            boxShadow: theme.shadows[1],
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            {t("familyOrders.noDeliveredOrders")}
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
            {t("familyOrders.noDeliveredOrdersDesc")}
          </Typography>
        </Box>
      )}

      {!loading &&
        (tabValue === 0 ? pendingOrders : deliveredOrders).map((order) => (
          <Paper
            key={order._id}
            sx={{
              p: isMobile ? 1 : 2,
              mb: isMobile ? 2 : 3,
              borderRadius: 2,
              boxShadow: theme.shadows[2],
              borderLeft: `4px solid ${getStatusColor(order.orderStatus)}`,
              backgroundColor: theme.palette.background.paper,
            }}
            elevation={2}
          >
            {/* Order Summary Header */}
            <Box
              sx={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                justifyContent: "space-between",
                alignItems: isMobile ? "flex-start" : "center",
                cursor: "pointer",
                p: isMobile ? 0.5 : 1,
                "&:hover": {
                  backgroundColor: theme.palette.action.hover,
                  borderRadius: 1,
                },
              }}
              onClick={() => toggleOrder(order._id)}
            >
              <Box sx={{ mb: isMobile ? 1 : 0 }}>
                <Typography variant="body2" color="text.secondary">
                  {t("orders.orderNumber")}
                </Typography>
                <Typography
                  variant={isMobile ? "body1" : "h6"}
                  fontWeight="bold"
                  color="primary"
                >
                  {order.orderId}
                </Typography>
              </Box>

              <Box sx={{ mb: isMobile ? 1 : 0 }}>
                <Typography variant="body2" color="text.secondary">
                  {t("orders.orderDate")}
                </Typography>
                <Typography variant={isMobile ? "body2" : "body1"}>
                  {formatDate(order.orderDate)}
                </Typography>
              </Box>

              <Box sx={{ mb: isMobile ? 1 : 0 }}>
                <Typography variant="body2" color="text.secondary">
                  {t("orders.totalPrice")}
                </Typography>
                <Typography
                  variant={isMobile ? "body2" : "body1"}
                  fontWeight="bold"
                  color="text.primary"
                >
                  {order.totalPrice.toFixed(2)} <span>{t("rs")}</span>
                </Typography>
              </Box>

              <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                sx={{ mb: isMobile ? 1 : 0 }}
              >
                <Box>{getStatusIcon(order.orderStatus)}</Box>
                <Typography
                  variant={isMobile ? "body2" : "body1"}
                  fontWeight="bold"
                  sx={{ color: getStatusColor(order.orderStatus) }}
                >
                  {getStatusText(order.orderStatus)}
                </Typography>
                <IconButton size={isMobile ? "small" : "medium"}>
                  {expandedOrders[order._id] ? (
                    <ExpandLessIcon />
                  ) : (
                    <ExpandMoreIcon />
                  )}
                </IconButton>
              </Stack>
            </Box>

            {/* Order Details - Collapsible */}
            <Collapse in={expandedOrders[order._id]}>
              <Divider sx={{ my: 1 }} />

              {/* Buyer Information */}
              <Box sx={{ mb: 2, mt: 2 }}>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{ mb: 1, display: "flex", alignItems: "center", gap: 1 }}
                >
                  <PersonIcon />
                  {t("familyOrders.buyerInfo")}
                </Typography>

                <Card
                  sx={{
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: 1,
                    overflow: "hidden",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      p: isMobile ? 1 : 2,
                    }}
                  >
                    <Avatar
                      src={order.buyer.avatar}
                      sx={{
                        width: isSmallMobile ? 50 : 60,
                        height: isSmallMobile ? 50 : 60,
                        mr: isRtl ? 0 : 2,
                        ml: isRtl ? 2 : 0,
                      }}
                    />
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        variant={isMobile ? "body1" : "h6"}
                        fontWeight="bold"
                      >
                        {order.buyer.name}
                      </Typography>

                      {order.buyer.phone && (
                        <Stack
                          direction="row"
                          alignItems="center"
                          spacing={1}
                          sx={{ mt: 0.5 }}
                        >
                          <Phone
                            fontSize="small"
                            color="action"
                            sx={{ ml: 1 }}
                          />
                          <Typography variant="body2">
                            {t("familyOrders.phone")}: {order.buyer.phone}
                          </Typography>
                        </Stack>
                      )}

                      {order.buyer.address && (
                        <Stack
                          direction="row"
                          alignItems="center"
                          spacing={1}
                          sx={{ mt: 0.5 }}
                        >
                          <Home
                            fontSize="small"
                            color="action"
                            sx={{ ml: 1 }}
                          />
                          <Typography
                            variant="body2"
                            sx={{
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 2,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {t("familyOrders.address")}: {order.buyer.address}
                          </Typography>
                        </Stack>
                      )}

                      {order.buyer.location && (
                        <Stack
                          direction="row"
                          alignItems="center"
                          spacing={1}
                          sx={{ mt: 0.5 }}
                        >
                          <LocationOn
                            fontSize="small"
                            color="action"
                            sx={{ ml: 1 }}
                          />
                          <Typography
                            variant="body2"
                            component="a"
                            href={order.buyer.location}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 2,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              color: "primary.main",
                              textDecoration: "none",
                              "&:hover": {
                                textDecoration: "underline",
                              },
                            }}
                          >
                            {t("userForm.fields.buyerLocation")}
                          </Typography>
                        </Stack>
                      )}
                    </Box>
                    <Button
                      variant="outlined"
                      size="small"
                      sx={{
                        minWidth: "unset",
                        fontSize: isMobile ? "0.75rem" : "0.875rem",
                      }}
                      onClick={() =>
                        (window.location.href = `tel:${order.buyer.phone}`)
                      }
                    >
                      {t("familyOrders.contact")}
                    </Button>
                  </Box>
                </Card>
              </Box>

              {/* Products Section */}
              <Box sx={{ mb: 1 }}>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{ mb: 1, display: "flex", alignItems: "center", gap: 1 }}
                >
                  <LocalShippingIcon />
                  {t("familyOrders.orderedProducts")}
                </Typography>
              </Box>

              <Grid container spacing={1}>
                {order.products.map((product) => (
                  <Grid item xs={12} key={product.id}>
                    <Card
                      sx={{
                        border: `1px solid ${theme.palette.divider}`,
                        borderRadius: 1,
                        overflow: "hidden",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          p: isMobile ? 1 : 2,
                        }}
                      >
                        <Avatar
                          src={product.image}
                          variant="rounded"
                          sx={{
                            width: isSmallMobile ? 50 : 60,
                            height: isSmallMobile ? 50 : 60,
                            mr: isRtl ? 0 : isMobile ? 1 : 2,
                            ml: isRtl ? (isMobile ? 1 : 2) : 0,
                          }}
                        />
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography
                            variant={isMobile ? "body2" : "subtitle1"}
                            fontWeight="bold"
                            sx={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {product.name}
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: isSmallMobile ? "column" : "row",
                              justifyContent: "space-between",
                              mt: 0.5,
                              gap: isSmallMobile ? 0.5 : 0,
                            }}
                          >
                            <Typography variant="body2" color="text.secondary">
                              {t("orders.quantity")}: {product.quantity}
                            </Typography>

                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{
                                fontSize: isMobile ? "0.8rem" : "0.875rem",
                              }}
                            >
                              {t("orders.unitPrice")} :{" "}
                              {product.price.toFixed(2)} <span>{t("rs")}</span>
                            </Typography>
                            <Typography variant="body2" fontWeight="bold">
                              {t("orders.totalPrice")} :{" "}
                              {(product.price * product.quantity).toFixed(2)}{" "}
                              <span>{t("rs")}</span>
                            </Typography>
                          </Box>
                        </Box>
                      </Box>

                      {/* <CardContent
                        sx={{
                          backgroundColor:
                            theme.palette.mode === "dark"
                              ? theme.palette.grey[900]
                              : theme.palette.grey[50],
                          borderTop: `1px solid ${theme.palette.divider}`,
                          pt: 0,
                          pb: "8px !important",
                          px: isMobile ? 1 : 2,
                        }}
                      >
                        <Typography 
                          variant="body2" 
                          sx={{ 
                            mb: 1,
                            fontSize: isMobile ? "0.8rem" : "0.875rem",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {product.description}
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: isSmallMobile ? "column" : "row",
                            justifyContent: "space-between",
                            alignItems: isSmallMobile ? "flex-start" : "center",
                            gap: isSmallMobile ? 0.5 : 0,
                          }}
                        >
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ fontSize: isMobile ? "0.8rem" : "0.875rem" }}
                          >
                            {t("orders.unitPrice")} : {product.price}{" "}
                            <span>{t("rs")}</span>
                          </Typography>
                        </Box>
                      </CardContent> */}
                    </Card>
                  </Grid>
                ))}
              </Grid>

              {/* Order Notes */}
              {order.notes && order.notes != "" && (
                <Box sx={{ mt: 2 }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    sx={{ mb: 1 }}
                  >
                    {t("familyOrders.orderNotes")}
                  </Typography>
                  <Typography variant="body2">{order.notes}</Typography>
                </Box>
              )}
              {/* Order Actions */}
              {tabValue === 0 && order.orderStatus === "pending" && (
                <Box
                  sx={{
                    mt: 3,
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 2,
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() =>{
                      setModalOrder(order)
                       setOpenDialog("cancelled")
                    }
                      }
                    // onClick={() => handleUpdateStatus(order._id, "cancelled")}
                    disabled={updatingOrders[order._id]}
                    sx={{ minWidth: 180 }}
                  >
                    {updatingOrders[order._id] ? (
                      <CircularProgress size={24} />
                    ) : (
                      t("familyOrders.markAsCanceled")
                    )}
                  </Button>

                  <Button
                    variant="contained"
                    color="success"
                     onClick={() => {
                      setModalOrder(order)
                       setOpenDialog("delivered")
                    }}
                    // onClick={() => handleUpdateStatus(order._id, "delivered")}
                    disabled={updatingOrders[order._id]}
                    sx={{ minWidth: 180 }}
                  >
                    {updatingOrders[order._id] ? (
                      <CircularProgress size={24} />
                    ) : (
                      t("familyOrders.markAsDelivered")
                    )}
                  </Button>
                </Box>
              )}
            </Collapse>
          </Paper>
        ))}
          <Dialog open={Boolean(openDialog)} onClose={() => setOpenDialog(null)}>
        <DialogTitle>
          {openDialog === "cancelled"
            ? t("familyOrders.confirmCancelTitle")
            : t("familyOrders.confirmDeliveredTitle")}
        </DialogTitle>
        <DialogContent>
          <Typography>
            {openDialog === "cancelled"
              ? t("familyOrders.confirmCancelMessage")
              : t("familyOrders.confirmDeliveredMessage")}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(null)} sx={{mx:1}}>
            {t("buttons.cancel")}
          </Button>
          <Button
            variant="contained"
            color={openDialog === "cancelled" ? "error" : "success"}
            onClick={handleConfirm}
          >
            {t("buttons.confirm")}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default FamilyOrders;
